import React from "react";
import { Typography } from "@mui/material";
import BasicBreadcrumbs from "../Breadcrumbs/Breadcrumbs";
import { Box } from "@mui/system";
import { PageTitleStyles } from "./PageTitleStyles";

const PageTitle = ({ title, PageIcon, iconColor, breadcrumbs = true }) => {
  return (
      <PageTitleStyles>
        <Box className="LabelIconBox">
            {PageIcon && <Box className="IconBox" sx={{ backgroundColor: iconColor }}>
            {PageIcon}
          </Box>}
          <Box className="titleBox">
            <Typography variant="h5" className="titleText">
              {title}
            </Typography>
            {breadcrumbs && <BasicBreadcrumbs title={title} />}
          </Box>
        </Box>
      </PageTitleStyles>
  );
};

export default PageTitle;
